import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PDFDocument } from 'pdf-lib'
import { FileHelper } from 'src/app/helpers';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-page-activity-review-lease-agreement-and-answer-rw',
  templateUrl: './page-activity-review-lease-agreement-and-answer-rw.component.html',
  styleUrls: ['./page-activity-review-lease-agreement-and-answer-rw.component.css', '../module-page-rw/module-page-rw.component.css']
})
export class PageActivityReviewLeaseAgreementAndAnswerRwComponent implements OnInit {

  @Input()
  backTitle = 'Back';

  @Input()
  nextTitle = 'Next';

  @Input()
  delay = true;

  @Output()
  back = new EventEmitter<Event>();

  @Output()
  next = new EventEmitter<Event>();

  questions = 16;

  content = {
    downloaded: false,
    validate:   false,
  };

  srcHandout: string = "../../../../../assets/RWM4A5Handout.pdf";
  pdfHandout!: PDFDocument;

  // When this value is false the answer will be revealed for activity five.
  qclick = new Array(this.questions).fill(true);

  previewByAdmin = this.auth.isSuperAdmin;
  // previewByAdmin = false;

  constructor(private auth: AuthService) { }

  async ngOnInit(): Promise<void> {
    const handoutFillablePdfBytes = await fetch(this.srcHandout).then(res => res.arrayBuffer());
    this.pdfHandout = await PDFDocument.load(handoutFillablePdfBytes);
  }

  goBack(event?: Event) {
    if (event?.defaultPrevented) return false;
    this.back.emit(event);
    return true;
  }

  goNext(event?: Event) {
    if (event?.defaultPrevented) return false;
    this.next.emit(event);
    return true;
  }

  async downloadActivityFive() {
    // Serialize the PDFDocument to bytes (a Uint8Array) for download
    const pdfBytes = await this.pdfHandout.save();
    FileHelper.saveByteArray('RWM4A5Handout.pdf', pdfBytes, 'application/pdf');
  }

  all<T = unknown>(array: T[], value: T) {
    return array.every(v => v === value);
  }

  allOf(obj: Object, value = true) {
    return this.all(Object.values(obj), value);
  }
}
